<template>
  <div>
    <CTabs :active-tab="activeTab">
      <CTab title="近隣グループの詳細" :to="{ name: '近隣グループの詳細', params: { id: id } }">
        <router-view />
      </CTab>
      <CTab title="近隣グループに所属する薬局一覧" :to="{ name: '近隣グループの薬局一覧', params: { id: id } }">
        <router-view />
      </CTab>
    </CTabs>
  </div>
</template>

<script>
export default {
  name: "GroupTabs",
  data() {
    return {
      id: null,
      fields: ["id", "name", "micode", "created_at", "actions"],
    };
  },
  computed: {
    activeTab() {
      return ["近隣グループの詳細", "近隣グループの薬局一覧"].indexOf(this.$route.name);
    },
  },
  created() {
    this.id = this.$route.params.id;
  },
};
</script>
